// const UsersListPage = () => import("./pages/users-list-page/UsersListPage.vue");

import DontLookupPage from "./pages/dont-lookup/DontLookupPage.vue";

// import { StatisticsStatsEmployeesBlock } from "statisticsStatsEmployeesSection/components";

const StatisticsStatsEmployeesBlock = () =>
  import("administration_employees_section/StatisticsStatsEmployeesBlock");

const statisticsRoutes = [
  {
    path: "",
    name: "employees",
    component: StatisticsStatsEmployeesBlock,
    meta: {
      name: "Сотрудники",
    },
  },
  {
    path: ":pathMatch(.*)*",
    component: DontLookupPage,
    meta: {},
  },
];

export default statisticsRoutes;
